'use strict';

angular.module('app.general').component('glossaryIconLink', {
  templateUrl: 'general/components/glossary-icon-link.html',
  selector: 'glossary-icon-link',
});
